var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _g2, _path0, _path1, _path10, _path11, _g3, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 93,
    viewBox: "0 0 130 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.2862 79.9998C84.3151 79.9998 100.553 63.9153 100.553 44.0046C100.553 24.0938 84.2435 8.00928 64.2862 8.00928C44.2573 8.00928 28.0195 24.0938 28.0195 44.0046C28.0195 63.9153 44.2573 79.9998 64.2862 79.9998Z",
    fill: "#E6EEFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1926 20.4096C99.8123 20.4096 101.125 19.109 101.125 17.5045C101.125 15.9 99.8123 14.5994 98.1926 14.5994C96.5728 14.5994 95.2598 15.9 95.2598 17.5045C95.2598 19.109 96.5728 20.4096 98.1926 20.4096Z",
    fill: "#E7EBF6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.485 9.07247C103.591 9.07247 104.488 8.18421 104.488 7.08848C104.488 5.99276 103.591 5.10449 102.485 5.10449C101.379 5.10449 100.482 5.99276 100.482 7.08848C100.482 8.18421 101.379 9.07247 102.485 9.07247Z",
    fill: "#E7EBF6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9516 20.3386C31.0578 20.3386 31.9545 19.4503 31.9545 18.3546C31.9545 17.2589 31.0578 16.3706 29.9516 16.3706C28.8455 16.3706 27.9487 17.2589 27.9487 18.3546C27.9487 19.4503 28.8455 20.3386 29.9516 20.3386Z",
    fill: "#E7EBF6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7197 58.6013C19.774 58.6013 21.4393 56.9517 21.4393 54.9167C21.4393 52.8818 19.774 51.2322 17.7197 51.2322C15.6653 51.2322 14 52.8818 14 54.9167C14 56.9517 15.6653 58.6013 17.7197 58.6013Z",
    fill: "#E7EBF6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_418_4265)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.2482 51.8759L36.9709 68.5879C35.5665 69.5453 33.6531 69.2146 32.6701 67.8219L16.5554 44.7908C15.5899 43.3981 15.9234 41.5006 17.3278 40.5257L41.6052 23.8138C43.0095 22.8563 44.9229 23.1871 45.9059 24.5797L62.0382 47.6109C63.0036 49.0036 62.6526 50.9185 61.2482 51.8759Z",
    fill: "url(#paint0_linear_418_4265)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4918 49.3519L36.146 64.0445C35.5492 64.4623 34.7241 64.3057 34.3028 63.7138L20.9792 44.6691C20.5579 44.0772 20.7159 43.259 21.3128 42.8412L42.6586 28.1486C43.2554 27.7308 44.0805 27.8875 44.5018 28.4794L57.8254 47.5241C58.2467 48.1159 58.0887 48.9341 57.4918 49.3519Z",
    fill: "#E5EDFE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2017 49.195L34.4077 54.5567L35.2328 47.5063L42.2017 49.195Z",
    fill: "#D4DEF4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6443 44.7559L37.4272 52.4852L38.6209 42.3362L48.6443 44.7559Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1435 46.8797C33.1324 46.8797 33.9341 46.0847 33.9341 45.104C33.9341 44.1234 33.1324 43.3284 32.1435 43.3284C31.1547 43.3284 30.353 44.1234 30.353 45.104C30.353 46.0847 31.1547 46.8797 32.1435 46.8797Z",
    fill: "#D5DFF5"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_418_4265)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.6509 66.0984L68.0939 47.1582C66.7949 46.0615 66.6369 44.1291 67.7252 42.8409L85.9991 21.4461C87.105 20.1579 89.0535 20.0013 90.3525 21.0806L112.91 40.0208C114.209 41.1175 114.367 43.0498 113.278 44.338L95.0044 65.7328C93.8984 67.021 91.9499 67.1777 90.6509 66.0984Z",
    fill: "url(#paint1_linear_418_4265)"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1432 61.8506L72.307 45.2083C71.7453 44.7382 71.6751 43.9201 72.1491 43.363L87.2456 25.6762C87.7196 25.1191 88.5446 25.0495 89.1063 25.5195L108.943 42.1618C109.504 42.6318 109.574 43.45 109.101 44.0071L94.004 61.6939C93.53 62.251 92.7049 62.3206 92.1432 61.8506Z",
    fill: "#E5EDFE"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3344 47.1409L81.1021 41.0654L88.1939 40.0383L88.3344 47.1409Z",
    fill: "#D4DEF4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3373 52.1715L83.9102 43.4152L94.1091 41.9529L94.3373 52.1715Z",
    fill: "#F3F5F7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7388 38.2451C90.7276 38.2451 91.5293 37.4502 91.5293 36.4695C91.5293 35.4888 90.7276 34.6938 89.7388 34.6938C88.7499 34.6938 87.9482 35.4888 87.9482 36.4695C87.9482 37.4502 88.7499 38.2451 89.7388 38.2451Z",
    fill: "#D4DEF4"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_418_4265)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.4377 46.6861L51.4008 52.2262C49.7239 52.5414 48.1049 51.4523 47.7736 49.8048L42.3969 22.2906C42.0767 20.6296 43.1747 19.0274 44.8379 18.7013L73.8748 13.1612C75.5517 12.8459 77.1707 13.9351 77.5019 15.5825L82.8786 43.0967C83.1989 44.7577 82.1009 46.3599 80.4377 46.6861Z",
    fill: "url(#paint2_linear_418_4265)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0303 42.8723L52.5064 47.7524C51.7846 47.8914 51.0969 47.4328 50.9558 46.7179L46.5045 23.9801C46.3634 23.2651 46.8257 22.5846 47.5475 22.4456L73.0714 17.5655C73.7933 17.4265 74.4809 17.8851 74.622 18.6001L79.0733 41.3379C79.2144 42.0529 78.7521 42.7333 78.0303 42.8723Z",
    fill: "#E5EDFE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0727 36.5929L54.7606 38.3674L58.3975 32.2497L64.0727 36.5929Z",
    fill: "#D4DEF4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7929 35.1121L58.3695 37.6724L63.6115 28.8837L71.7929 35.1121Z",
    fill: "#F3F5F7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9554 29.9336C58.5751 29.1703 58.4522 28.0533 57.6808 27.4387C56.9094 26.824 55.7816 26.9445 55.1618 27.7078C54.542 28.4711 54.6649 29.5881 55.4363 30.2027C56.2078 30.8174 57.3356 30.6969 57.9554 29.9336Z",
    fill: "#D4DEF4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8314 63.9649C80.4902 65.4015 79.9784 66.9226 79.3812 68.1901C77.7603 71.3168 75.2011 73.7674 72.0447 75.3729C68.803 76.9785 64.9641 77.6545 61.1252 76.8095C52.0825 74.9504 46.2815 66.162 48.1583 57.2047C50.0351 48.2473 58.8219 42.4166 67.8646 44.3601C71.1063 45.0362 73.9215 46.6417 76.3101 48.8388C80.3196 52.8105 82.0258 58.5567 80.8314 63.9649Z",
    fill: "#0057FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8268 59.1482H65.988V55.3455C65.988 54.585 65.3908 53.9089 64.5377 53.9089C63.7699 53.9089 63.0875 54.5005 63.0875 55.3455V59.1482H59.2486C58.4808 59.1482 57.7983 59.7397 57.7983 60.5847C57.7983 61.4297 58.3955 62.0213 59.2486 62.0213H63.0875V65.8239C63.0875 66.5845 63.6846 67.2605 64.5377 67.2605C65.3055 67.2605 65.988 66.669 65.988 65.8239V62.0213H69.8268C70.5946 62.0213 71.2771 61.4297 71.2771 60.5847C71.2771 59.7397 70.5946 59.1482 69.8268 59.1482Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_418_4265",
    x: 0.206604,
    y: 15.3687,
    width: 78.1747,
    height: 77.4625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.89914
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.89914
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_418_4265"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_418_4265",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_418_4265",
    x: 51.2051,
    y: 12.4656,
    width: 78.5931,
    height: 78.046,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.89914
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.89914
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_418_4265"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_418_4265",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_418_4265",
    x: 26.543,
    y: 5.20779,
    width: 72.1893,
    height: 70.7701,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.89914
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.89914
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_418_4265"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_418_4265",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_418_4265",
    x1: 39.2787,
    y1: 22.2069,
    x2: 39.2787,
    y2: 69.6283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_418_4265",
    x1: 90.4864,
    y1: 19.2903,
    x2: 90.4864,
    y2: 67.315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_418_4265",
    x1: 43.5136,
    y1: 17.4759,
    x2: 81.0096,
    y2: 47.9228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFile);
export default __webpack_public_path__ + "static/media/AddFile.84fcb2b6477ccf2bfa101d9593973c8a.svg";
export { ForwardRef as ReactComponent };